<template>
  <div class="logo-item">
    <div class="title">
      <span>{{info.title}}</span>
    </div>
    <div class="item-wrap">
      <div class="item" v-for="(item, i) in info.logoList" :key="i" @click="goDetail">
        <img :src="item.logoImg" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    info: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  methods: {
    goDetail () {
      if (this.info.link) {
        window.open(this.info.link, '_blank')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.logo-item {

  & .title {
    margin-bottom: 30px;
    border-bottom: 1px solid $lineGray;

    @include isMobile {
      margin-bottom: 20px;
    }

    & span {
      display: inline-block;
      padding: 0 14px;
      background: linear-gradient(to right, $blue, $green);
      border-radius: 4px 4px 0 0;
      line-height: 30px;
      color: #FFF;
      @include font(15, 400);

      @include isMobile {
        padding: 0 12px;
        line-height: 25px;
        @include font(12, 500);
      }
    }
  }

  & .item-wrap {
    display: flex; flex-wrap: wrap;
    @include isMobile {
      justify-content: space-between;
    }
    & .item {
      position: relative;
      margin-right: 24px;
      margin-bottom: 25px;
      width: 170px;
      height: 70px;
      box-shadow: 0px 4px 22px 1px rgba(0, 0, 0, 0.05);
      

      @include isMobile {
        margin-right: 0px;
        margin-bottom: 20px;
        width: 151px; height: 62px;
      }

      &:nth-child(6n) {
        margin-right: 0;
      }

      & img {
        position: absolute; top: 50%; left: 50%;
        transform: translateX(-50%) translateY(-50%);
        width: 100%;
        border-radius: 5px;
      }
    }
  }
}
</style>